import { DIRECT_PURCHASE_SET, DIRECT_PURCHASE_CLEAR } from '../constants/cartConstants';

const directPurchaseInitialState = {
  product: null,
  qty: 1,
  size: '',
};

export const directPurchaseReducer = (state = directPurchaseInitialState, action) => {
  switch(action.type) {
    case DIRECT_PURCHASE_SET:
      return {
        product: action.payload.product,
        qty: action.payload.qty,
        size: action.payload.size,
      };
    case DIRECT_PURCHASE_CLEAR:
      return directPurchaseInitialState;
    default:
      return state;
  }
};
